import { combineReducers } from 'redux';
import userManagerReducer from '../modules/UserManager/redux/userManagerReducer';
import authReducer from '../modules/login/redux/authReducer';
import notificationsReducer from '../modules/container/notifications/notificationsRedux/notificationReducer';
import tenantsReducer from '../modules/TenantManager/redux/reducer';
import tenantUserManagerReducer from '../modules/TenantManager/detail/UserManager/redux/tenantUserManagerReducer';

export default combineReducers({
  userManagerReducer,
  authReducer,
  notificationsReducer,
  tenantsReducer,
  tenantUserManagerReducer,
});
